import React from "react";
import Footer from "./Footer";

export default function FullPageBackgroundContainer({ children, background }) {
  return (
    <div className="page--container">
      <div className="page--container__content">
        <div className={background}>{children}</div>
        <Footer />
      </div>
    </div>
  );
}
